import { createSelector } from 'reselect';

import { sortByProp } from 'app/common/lib/sort';


const selectCartItems = createSelector(
  [
    state => state.shop.cart.cartItems,
  ],
  sortByProp('name'),
);

export default selectCartItems;
